const screenViewTemplate = {
  event: 'screen_view', // A default GA4 event
  screen_name: null, // A literal
  store_id: null, // The SH Store ID as string (for compatibility with OB & TB)
  store_country: null, // The two-letter ISO code of the country, such as “ES”
  visit_platform: 'sh-web', // One of “sh-web”, “sh-ios”, “sh-android”
  visit_locale: null, // The locale of the current pageview, such as “es-ES”
  visit_advisory_currency: null, // One of “OFF”, “NONE”, “EUR”, “USD”, etc.
  visit_guid: null, // The current user's GUID if logged-in, null otherwise (probably always null)
  redirect: null, // The unencoded value in the URL, if any
  is_guest: null, // Whether the visit is a guest checkout user or not
  visit_country: null, // The two letter ISO code of the visitor’s current country
  visit_city: null, // The english name of the visitor’s current city
  visit_coords: null, // The user’s current coords in the form "43.262985,-2.935013”
};

export default screenViewTemplate;
